module.exports = __webpack_public_path__ + "img/ic_nat_home_kdjl.2b7b0353.png";